import { Header, RichTextDisplay } from "@datagame/ui";
import { indexOf } from "lodash";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

import { Timer, TimerSize, TimerVariant } from "../../shared/Timer";
import { TriviaQuestion } from "../../../gql/graphql";

import styles from "./QuestionSection.module.scss";
import { GLAUKOS_PROJECT_ID_PRODUCTION, GLAUKOS_PROJECT_ID_STAGING } from "../../../main";
import classNames from "classnames/bind";

export interface QuestionSectionProps {
  allQuestions: TriviaQuestion[];
  question: TriviaQuestion;
  score: number;
}

const cx = classNames.bind(styles);

export const QuestionSection = (props: QuestionSectionProps) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });
  const { t } = useTranslation("trivia");

  const isGlaukosProject =
    window.location.pathname.includes(GLAUKOS_PROJECT_ID_PRODUCTION) ||
    window.location.pathname.includes(GLAUKOS_PROJECT_ID_STAGING);

  const { question: currentQuestion, score, allQuestions } = props;
  const questionImage = currentQuestion.image;
  const questionVideo = currentQuestion.video;

  const renderMedia = () => {
    if (questionVideo) {
      // eslint-disable-next-line jsx-a11y/media-has-caption
      return <video className={styles.media} src={questionVideo.url} controls />;
    }
    if (questionImage) {
      return <img className={styles.media} src={questionImage.url} alt={questionImage.name} />;
    }
    return null;
  };

  return (
    <div className={styles.questionSection}>
      {renderMedia()}
      <div className={cx("questionWrapper", { isGlaukosProject })} id="questionWrapper">
        <div className={styles.panel}>
          <div className={styles.score}>
            {t("score")}
            <span className={styles.mark}>{score}</span>
          </div>
          <Timer
            className={styles.timer}
            variant={TimerVariant.CIRCLE}
            size={isDesktop ? TimerSize.MEDIUM : TimerSize.SMALL}
          />
          <div className={styles.number}>
            {t("questionNumber")}
            <span className={styles.mark}>{indexOf(allQuestions, currentQuestion) + 1}</span>/{allQuestions.length}
          </div>
        </div>
        <Header className={styles.textHeader} variant="h6">
          <RichTextDisplay value={currentQuestion.question} />
        </Header>
      </div>
    </div>
  );
};
